var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',[_c('LoaderSVG')],1)]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }